export const getViewportWidth = () => document.documentElement.clientWidth;

export const getViewportHeight = () => document.documentElement.clientHeight;
